import { Panel, PanelType, Pivot, PivotItem, TooltipHost } from "office-ui-fabric-react";
import * as React from "react";
import { RoomType } from "../../../types/SiteLocation.types";
import RoomBookingSearch from "./RoomBookingSearch";
import SiteLocRoomList from "./SiteLocRoomList";

export interface IRoomBookingTopProps {
    onDismiss: () => void;
    roomType: RoomType;
}

export const RoomBookingTop = (props: IRoomBookingTopProps) => {
    const [selectedPivotItem, setSelectedPivotItem] = React.useState("0");
    return (
        <Panel type={PanelType.custom} customWidth="900px"
            isOpen={true} headerText={props.roomType === RoomType.MeetingRoom ? "Meeting Room Availability" : "Clinical Room Availability"}
            onDismiss={props.onDismiss} layerProps={{ eventBubblingEnabled: true }}
        >
            <Pivot onLinkClick={(item) => { setSelectedPivotItem(item?.props.itemKey as string) }} selectedKey={ selectedPivotItem }>
                <PivotItem itemKey="0"
                    onRenderItemLink={(pivotItemProps, defaultRender) => (
                        <TooltipHost content="Choose this option when you need a room for a particular date and time">
                            { defaultRender !== undefined && defaultRender(pivotItemProps) }
                        </TooltipHost>
                    )} 
                    headerText="Find room by date/time"
                >
                    <RoomBookingSearch roomType={props.roomType} onViewCalendars={() => { setSelectedPivotItem("1"); }} /> 
                </PivotItem>
                <PivotItem itemKey="1"
                    onRenderItemLink={(pivotItemProps, defaultRender) => (
                        <TooltipHost content="Choose this option to view room calendars, and find availability for a particular room">
                            { defaultRender !== undefined && defaultRender(pivotItemProps) }
                        </TooltipHost>
                    )} 
                    headerText="Specific room availability"
                >
                    <SiteLocRoomList roomType={props.roomType} />
                </PivotItem>                
            </Pivot>
        </Panel>
    );
};